/**
 * ============================================================
 * KEJJA OS — Currencies (ISO 4217)
 * ============================================================
 */

export interface CurrencyDef {
  code: string;    // ISO 4217 (e.g. "KES")
  name: string;    // Full name (e.g. "Kenyan Shilling")
  symbol: string;  // Display symbol (e.g. "Ksh")
}

export const CURRENCIES: CurrencyDef[] = [
  // East Africa
  { code: 'KES', name: 'Kenyan Shilling', symbol: 'Ksh' },
  { code: 'UGX', name: 'Ugandan Shilling', symbol: 'USh' },
  { code: 'TZS', name: 'Tanzanian Shilling', symbol: 'TSh' },
  { code: 'RWF', name: 'Rwandan Franc', symbol: 'RF' },
  { code: 'BIF', name: 'Burundian Franc', symbol: 'FBu' },
  { code: 'ETB', name: 'Ethiopian Birr', symbol: 'Br' },
  { code: 'SOS', name: 'Somali Shilling', symbol: 'Sh' },
  { code: 'SSP', name: 'South Sudanese Pound', symbol: '£' },
  { code: 'SDG', name: 'Sudanese Pound', symbol: 'ج.س.' },

  // West & Central Africa
  { code: 'NGN', name: 'Nigerian Naira', symbol: '₦' },
  { code: 'GHS', name: 'Ghanaian Cedi', symbol: '₵' },
  { code: 'XOF', name: 'CFA Franc BCEAO', symbol: 'CFA' },
  { code: 'XAF', name: 'CFA Franc BEAC', symbol: 'FCFA' },
  { code: 'LRD', name: 'Liberian Dollar', symbol: 'L$' },
  { code: 'SLL', name: 'Sierra Leonean Leone', symbol: 'Le' },

  // Southern Africa
  { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
  { code: 'ZWL', name: 'Zimbabwean Dollar', symbol: 'Z$' },
  { code: 'ZMW', name: 'Zambian Kwacha', symbol: 'ZK' },
  { code: 'BWP', name: 'Botswana Pula', symbol: 'P' },
  { code: 'NAD', name: 'Namibian Dollar', symbol: 'N$' },
  { code: 'MZN', name: 'Mozambican Metical', symbol: 'MT' },
  { code: 'MWK', name: 'Malawian Kwacha', symbol: 'MK' },
  { code: 'AOA', name: 'Angolan Kwanza', symbol: 'Kz' },

  // North Africa
  { code: 'EGP', name: 'Egyptian Pound', symbol: 'E£' },
  { code: 'MAD', name: 'Moroccan Dirham', symbol: 'DH' },
  { code: 'DZD', name: 'Algerian Dinar', symbol: 'DA' },
  { code: 'TND', name: 'Tunisian Dinar', symbol: 'DT' },
  { code: 'LYD', name: 'Libyan Dinar', symbol: 'LD' },

  // Major globals
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
  { code: 'ARS', name: 'Argentine Peso', symbol: '$' },
  { code: 'MXN', name: 'Mexican Peso', symbol: '$' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
  { code: 'DKK', name: 'Danish Krone', symbol: 'kr' },
  { code: 'PLN', name: 'Polish Zloty', symbol: 'zł' },
];

export function findCurrency(code: string): CurrencyDef | undefined {
  return CURRENCIES.find((c) => c.code === code.toUpperCase());
}
